import { Tableau } from '../../common/utilities/TableauLog';
import { L10n } from '../L10n/L10n';
import { Module } from '../Module';

export module MissingTranslationService {

  export let MissingTranslationHandlerName = 'missingTranslation';

  Module.instance().factory(MissingTranslationHandlerName,
    () => {
        return (key: string) => {
            Tableau.Logger().error(`missing '${L10n.language}' translation for key: ${key}`);
        };
    }
  );

}
